import Head from 'next/head'
import Image from 'next/image'
// import styles from '../styles/Home.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTag,  } from '@fortawesome/free-solid-svg-icons';
import { faHeart } from '@fortawesome/free-regular-svg-icons';
import HeaderComponent from "../components/Header";
import NavigationComponent from "../components/HeaderNavigation";
import CarouselComponent from "../components/Carousel";
import ProductsComponent from "../components/Products";
import FooterComponent from "../components/Footer";
import { useState, useEffect } from 'react';
import { useSession } from 'next-auth/react';
import { toBackend } from '../utilities/requestsTypes';
import { ToastContainer, toast } from "react-toastify";

export default function Home() {

  const [productsProps, setProducts] = useState({
    productTitle: "Hot Deals",
    products: {
      docs: [],
      page: 1,
      totalPages: 0,
      totalDocs: 0,
      limit: 10,
      hasPrevPage: false,
      hasNextPage: false
    }
  });

  const {data} = useSession();

  // const auth = getAuth(app);

  // const showUser = () => {
  //   onAuthStateChanged(auth, (user) => {
  //     console.log(user);
  //   });
  //   console.log(authUser);
  // }


  useEffect(function() {
    getProducts();
  }, []);

  // useEffect(() => {
  //   console.log(authUser);
  // }, [authUser]);

  const getProducts = async (page=1, limit=10) => {
    try {
      const results = await toBackend.get(`products/all-products`, {
        headers: {
          accesstoken: data && data.user.token ? data.user.token : null
        }
      });

      console.log(results.data);

      setProducts({
        productTitle: "Hot Deals",
        products: results.data
      });
      console.log(results.data);
      console.log("Here");
    } catch (error) {
      console.log(error);
    }
  }
  
  const [carProps, setCarousel] = useState([
    {
      url: "65aecca1f6488041a9f221f84fe1b12e.jpeg",
      writeup: (<div className={`absolute left-[50%] flex flex-col gap-y-4 md:gap-y-6 xl:gap-y-10 leading-5 md:leading-10 top-[50%] z-10 translate-y-[-50%] translate-x-[-50%] xl:text-[48px] text-xl xl:w-[480px] w-[200px] font-bold text-white text-center`}>
      <div>Save more money</div>
  <div>when you buy less </div>
  <div>and <span className={`text-yellow`}>swap</span> more</div>
      </div>)
    },
    {
      url: "windowsphone.jpg",
      writeup: ``
    },
    {
      url: "library.jpg",
      writeup: ``
    }
    ]);

    

    // const [popularProducts, setPopularProducts] = useState({
    //   productTitle: "Popular Products",
    //   products: []
    // });

    // const [recommendedProducts, setRecommendedProducts] = useState({
    //   productTitle: "Recommended",
    //   products: []
    // });

  return (
    <div>
      <ToastContainer />
      <Head>
        <title>BartCash</title>
      </Head>

      <HeaderComponent />

      <hr />

      <NavigationComponent />

      <hr />


      <CarouselComponent carouselProperties={carProps} />

      <ProductsComponent productsProps={productsProps} getProducts={getProducts} setProducts={setProducts} />

      {/* <ProductsComponent productsProps={popularProducts} /> */}

      {/* <AuctionComponent auctionProps={auction} /> */}

      {/* <ProductsComponent productsProps={recommendedProducts} /> */}

      <FooterComponent />

    </div>
  )
}
